/* @jsx createElement */ /* @jsxFrag Fragment */ const $192dba6b716d8535$var$VOID = Symbol("VOID");
const $192dba6b716d8535$var$ROOT = Symbol("ROOT");
const $192dba6b716d8535$var$TEXT = Symbol("TEXT");
const $192dba6b716d8535$export$ffb0004e005737fa = Symbol("FRAGMENT");
let $192dba6b716d8535$var$scheduler = window.requestIdleCallback ?? ((cb)=>{
    // eslint-disable-next-line n/no-callback-literal
    cb({
        timeRemaining: ()=>1,
        didTimeout: false
    });
    return 1;
});
let $192dba6b716d8535$var$_nextUnitOfWork;
let $192dba6b716d8535$var$_currentRoot = null;
let $192dba6b716d8535$var$_wipRoot = null;
let $192dba6b716d8535$var$_firstEffect = null;
let $192dba6b716d8535$var$_lastEffect = null;
let $192dba6b716d8535$var$_hookIndex = -1;
const $192dba6b716d8535$var$_isStateHook = (hook)=>hook.type === "state";
const $192dba6b716d8535$var$_isMemoHook = (hook)=>hook.type === "memo";
const $192dba6b716d8535$var$_isEffectHook = (hook)=>hook.type === "effect";
const $192dba6b716d8535$var$_scheduleEffect = (fiber)=>{
    if (!$192dba6b716d8535$var$_lastEffect) {
        $192dba6b716d8535$var$_firstEffect = fiber;
        $192dba6b716d8535$var$_lastEffect = $192dba6b716d8535$var$_firstEffect;
    } else {
        $192dba6b716d8535$var$_lastEffect.nextEffect = fiber;
        $192dba6b716d8535$var$_lastEffect = fiber;
    }
};
const $192dba6b716d8535$var$_propsEqual = ({ children: _1, ...a }, { children: _2, ...b })=>{
    const aKeys = Object.keys(a);
    if (aKeys.length !== Object.keys(b).length) return false;
    return aKeys.every((key)=>a[key] === b[key]);
};
const $192dba6b716d8535$var$_depsEqual = (a = [], b = [])=>{
    if (a.length !== b.length) return false;
    return a.every((val, i)=>val === b[i]);
};
const $192dba6b716d8535$var$_getEffects = (fiber)=>fiber.hooks.filter($192dba6b716d8535$var$_isEffectHook).filter(({ depsChanged: depsChanged })=>depsChanged);
const $192dba6b716d8535$var$_runCleanup = (fiber)=>{
    fiber.hooks.forEach((hook)=>{
        if (hook.type === "effect") hook.cleanup?.();
    });
};
const $192dba6b716d8535$export$c8a8987d4410bf2d = (elementType, props, ...children)=>{
    // eslint-disable-next-line @typescript-eslint/naming-convention
    const { __self: __self, __source: __source, key: key = null, ...otherProps } = props ?? {};
    return {
        type: elementType,
        key: key,
        props: {
            ...otherProps,
            children: children
        }
    };
};
const $192dba6b716d8535$var$_createFiber = (overrides)=>({
        key: null,
        props: {},
        hooks: [],
        index: 0,
        visited: false,
        child: null,
        sibling: null,
        return: null,
        dom: null,
        effectTag: null,
        nextEffect: null,
        alternate: null,
        ...overrides
    });
const $192dba6b716d8535$var$_toEventName = (prop)=>prop.slice(2).toLowerCase();
const $192dba6b716d8535$var$_isHandler = (prop)=>prop.startsWith("on");
const $192dba6b716d8535$var$_isProp = (prop)=>!$192dba6b716d8535$var$_isHandler(prop);
const $192dba6b716d8535$var$_diffProps = ({ children: _c1, key: _k1, ...prev }, { children: _c2, key: _k2, ...curr })=>{
    const prevKeys = Object.keys(prev);
    const currKeys = Object.keys(curr);
    const isAdded = (key)=>!prev[key] || curr[key] !== prev[key];
    const isRemoved = (key)=>!curr[key] || curr[key] !== prev[key];
    return {
        added: {
            props: currKeys.filter($192dba6b716d8535$var$_isProp).filter(isAdded),
            handlers: currKeys.filter($192dba6b716d8535$var$_isHandler).filter(isAdded)
        },
        removed: {
            props: prevKeys.filter($192dba6b716d8535$var$_isProp).filter(isRemoved),
            handlers: prevKeys.filter($192dba6b716d8535$var$_isHandler).filter(isRemoved)
        }
    };
};
const $192dba6b716d8535$var$_getParentDom = (fiber)=>{
    let parentFiber = fiber.return;
    while(!parentFiber?.dom)parentFiber = parentFiber?.return ?? null;
    const parentDom = parentFiber?.dom;
    return parentDom;
};
const $192dba6b716d8535$var$_getFirstDom = (fiber)=>{
    switch(fiber.tag){
        case "void":
            return null;
        case "hostComponent":
        case "hostText":
            return fiber.dom;
        case "functionComponent":
        case "fragment":
            {
                let child = fiber.child;
                while(child){
                    const dom = $192dba6b716d8535$var$_getFirstDom(child);
                    if (dom) return dom;
                    child = child.sibling;
                }
                return null;
            }
        default:
            throw new Error("WAT");
    }
};
const $192dba6b716d8535$var$_removeDom = (fiber, domParent)=>{
    switch(fiber.tag){
        case "void":
            break;
        case "hostComponent":
        case "hostText":
            if (fiber.dom) domParent.removeChild(fiber.dom);
            break;
        case "functionComponent":
            $192dba6b716d8535$var$_runCleanup(fiber);
        // eslint-disable-next-line no-fallthrough
        case "fragment":
            {
                let child = fiber.child;
                while(child){
                    $192dba6b716d8535$var$_removeDom(child, domParent);
                    child = child.sibling;
                }
                break;
            }
        default:
            throw new Error("WAT");
    }
};
const $192dba6b716d8535$var$_getSiblingDom = (fiber)=>{
    let sibling = fiber?.alternate?.sibling ?? null;
    while(sibling){
        const dom = $192dba6b716d8535$var$_getFirstDom(sibling);
        if (dom) return dom;
        sibling = sibling.sibling;
    }
    if (fiber.return && !fiber.return.dom) return $192dba6b716d8535$var$_getSiblingDom(fiber.return);
    return null;
};
const $192dba6b716d8535$var$_reorderSiblings = (fiber, start)=>{
    let curr = fiber;
    while(curr?.sibling){
        if (curr.sibling.key === start.key) curr.sibling = curr.sibling.sibling;
        curr = curr.sibling;
    }
    start.sibling = fiber;
    return start;
};
const $192dba6b716d8535$var$_createDom = (fiber)=>{
    if (fiber.type === $192dba6b716d8535$var$TEXT) return document.createTextNode(fiber.props.nodeValue);
    if (typeof fiber.type === "string") return document.createElement(fiber.type);
    return null;
};
const $192dba6b716d8535$var$_isArray = (el)=>Array.isArray(el);
const $192dba6b716d8535$var$_isVoid = (el)=>el === null || typeof el === "undefined" || typeof el === "boolean";
const $192dba6b716d8535$var$_isText = (el)=>typeof el === "string" || typeof el === "number";
const $192dba6b716d8535$var$_isElement = (el)=>!$192dba6b716d8535$var$_isVoid(el) && !$192dba6b716d8535$var$_isArray(el) && !$192dba6b716d8535$var$_isText(el);
const $192dba6b716d8535$var$_getKey = (el)=>{
    if ($192dba6b716d8535$var$_isArray(el) || $192dba6b716d8535$var$_isText(el) || $192dba6b716d8535$var$_isVoid(el)) return null;
    return el.key;
};
const $192dba6b716d8535$var$_getWorkTag = (el)=>{
    if ($192dba6b716d8535$var$_isArray(el)) return "fragment";
    if ($192dba6b716d8535$var$_isText(el)) return "hostText";
    if ($192dba6b716d8535$var$_isVoid(el)) return "void";
    if (el.type === $192dba6b716d8535$export$ffb0004e005737fa) return "fragment";
    if (typeof el.type === "string") return "hostComponent";
    if (typeof el.type === "function") return "functionComponent";
    return "hostComponent";
};
const $192dba6b716d8535$var$_getWorkType = (el)=>{
    if ($192dba6b716d8535$var$_isArray(el)) return $192dba6b716d8535$export$ffb0004e005737fa;
    if ($192dba6b716d8535$var$_isText(el)) return $192dba6b716d8535$var$TEXT;
    if ($192dba6b716d8535$var$_isVoid(el)) return $192dba6b716d8535$var$VOID;
    return el.type;
};
const $192dba6b716d8535$var$_getProps = (el)=>{
    if ($192dba6b716d8535$var$_isArray(el)) return {
        children: el
    };
    if ($192dba6b716d8535$var$_isText(el)) return {
        nodeValue: el
    };
    if ($192dba6b716d8535$var$_isVoid(el)) return {};
    return el.props;
};
const $192dba6b716d8535$var$_updateFunctionComponent = (fiber)=>{
    $192dba6b716d8535$var$_hookIndex = -1;
    fiber.props = {
        ...fiber.props,
        children: [
            fiber.type(fiber.props)
        ]
    };
};
const $192dba6b716d8535$var$_updateHostComponent = (fiber)=>{
    if (!fiber.dom) fiber.dom = $192dba6b716d8535$var$_createDom(fiber);
};
const $192dba6b716d8535$var$_updateDom = (el, prevProps, props)=>{
    const { removed: removed, added: added } = $192dba6b716d8535$var$_diffProps(prevProps, props);
    removed.props.forEach((p)=>{
        el.removeAttribute(p === "className" ? "class" : p);
    });
    removed.handlers.forEach((h)=>{
        el.removeEventListener($192dba6b716d8535$var$_toEventName(h), prevProps[h]);
    });
    added.props.forEach((p)=>{
        switch(p){
            case "className":
                el.className = props[p];
                break;
            case "value":
            case "checked":
                el[p] = props[p];
            // eslint-disable-next-line no-fallthrough
            default:
                el.setAttribute(p, props[p]);
                break;
        }
    });
    added.handlers.forEach((h)=>{
        el.addEventListener($192dba6b716d8535$var$_toEventName(h), props[h]);
    });
};
const $192dba6b716d8535$var$_beginWork = (fiber)=>{
    if (fiber.visited) return null;
    fiber.visited = true;
    if (fiber.tag === "root") ;
    else if (!fiber.alternate) {
        fiber.effectTag = "add";
        $192dba6b716d8535$var$_scheduleEffect(fiber);
    } else {
        let keyMismatch = false;
        if (fiber.key !== null && fiber.key !== fiber.alternate.key) {
            let alt = fiber.alternate;
            while(alt && alt.key !== fiber.key)alt = alt.sibling;
            if (alt) {
                fiber.alternate = $192dba6b716d8535$var$_reorderSiblings(fiber.alternate, alt);
                fiber.hooks = fiber.alternate.hooks;
                fiber.dom = fiber.alternate.dom;
            } else keyMismatch = true;
        }
        if (keyMismatch || fiber.type !== fiber.alternate.type) {
            const alt = fiber.alternate;
            fiber.hooks = [];
            fiber.dom = null;
            fiber.alternate = $192dba6b716d8535$var$_createFiber({
                ...alt,
                child: null
            });
            fiber.effectTag = "add";
            $192dba6b716d8535$var$_scheduleEffect(fiber);
            alt.effectTag = "remove";
            $192dba6b716d8535$var$_scheduleEffect(alt);
        } else if (!$192dba6b716d8535$var$_propsEqual(fiber.alternate.props, fiber.props)) {
            fiber.effectTag = "update";
            $192dba6b716d8535$var$_scheduleEffect(fiber);
        }
    }
    switch(fiber.tag){
        case "functionComponent":
            $192dba6b716d8535$var$_updateFunctionComponent(fiber);
            if (!fiber.effectTag && fiber.hooks.length) $192dba6b716d8535$var$_scheduleEffect(fiber);
            break;
        case "hostText":
        case "hostComponent":
            $192dba6b716d8535$var$_updateHostComponent(fiber);
            break;
        default:
            break;
    }
    const { children: children = [] } = fiber.props;
    if (children.length) {
        const c = children[0];
        const tag = $192dba6b716d8535$var$_getWorkTag(c);
        const childFiber = $192dba6b716d8535$var$_createFiber({
            tag: tag,
            key: $192dba6b716d8535$var$_getKey(c),
            type: $192dba6b716d8535$var$_getWorkType(c),
            props: $192dba6b716d8535$var$_getProps(c),
            hooks: tag === "void" ? [] : fiber.alternate?.child?.hooks ?? [],
            dom: tag === "void" ? null : fiber.alternate?.child?.dom ?? null,
            index: 0,
            return: fiber,
            alternate: fiber.alternate?.child ?? null
        });
        fiber.child = childFiber;
        return childFiber;
    }
    let altChild = fiber.alternate?.child;
    while(altChild){
        altChild.effectTag = "remove";
        $192dba6b716d8535$var$_scheduleEffect(altChild);
        altChild = altChild.sibling;
    }
    return null;
};
const $192dba6b716d8535$var$_completeWork = (fiber)=>{
    const siblings = fiber.return?.props.children ?? [];
    const index = fiber.index + 1;
    if (index in siblings) {
        const s = siblings[index];
        const tag = $192dba6b716d8535$var$_getWorkTag(s);
        const siblingFiber = $192dba6b716d8535$var$_createFiber({
            tag: tag,
            key: $192dba6b716d8535$var$_getKey(s),
            type: $192dba6b716d8535$var$_getWorkType(s),
            props: $192dba6b716d8535$var$_getProps(s),
            hooks: tag === "void" ? [] : fiber.alternate?.sibling?.hooks ?? [],
            dom: tag === "void" ? null : fiber.alternate?.sibling?.dom ?? null,
            index: index,
            return: fiber.return,
            alternate: fiber.alternate?.sibling ?? null
        });
        fiber.sibling = siblingFiber;
        return siblingFiber;
    }
    let altSibling = fiber.alternate?.sibling;
    while(altSibling){
        altSibling.effectTag = "remove";
        $192dba6b716d8535$var$_scheduleEffect(altSibling);
        altSibling = altSibling.sibling;
    }
    return fiber.return;
};
const $192dba6b716d8535$var$_performUnitOfWork = (fiber)=>$192dba6b716d8535$var$_beginWork(fiber) ?? $192dba6b716d8535$var$_completeWork(fiber);
const $192dba6b716d8535$var$_commitWork = (effectFiber)=>{
    const effects = [];
    let curr = effectFiber;
    while(curr){
        switch(curr.effectTag){
            case "add":
                if (curr.dom instanceof HTMLElement) $192dba6b716d8535$var$_updateDom(curr.dom, {}, curr.props);
                if (curr.dom) $192dba6b716d8535$var$_getParentDom(curr).insertBefore(curr.dom, $192dba6b716d8535$var$_getSiblingDom(curr));
                effects.push(...$192dba6b716d8535$var$_getEffects(curr));
                break;
            case "update":
                if (curr.dom instanceof Text) curr.dom.nodeValue = curr.props.nodeValue;
                else if (curr.dom instanceof HTMLElement) $192dba6b716d8535$var$_updateDom(curr.dom, curr.alternate?.props ?? {}, curr.props);
                effects.push(...$192dba6b716d8535$var$_getEffects(curr));
                break;
            case "remove":
                $192dba6b716d8535$var$_removeDom(curr, $192dba6b716d8535$var$_getParentDom(curr));
                break;
            default:
                effects.push(...$192dba6b716d8535$var$_getEffects(curr));
                break;
        }
        const tmp = curr;
        curr = curr.nextEffect;
        tmp.effectTag = null;
        tmp.nextEffect = null;
    }
    effects.forEach((effect)=>{
        effect.cleanup?.();
        effect.cleanup = effect.setup() ?? undefined;
    });
};
const $192dba6b716d8535$var$_workLoop = (deadline)=>{
    if (!$192dba6b716d8535$var$_nextUnitOfWork && $192dba6b716d8535$var$_wipRoot) {
        $192dba6b716d8535$var$_currentRoot = $192dba6b716d8535$var$_wipRoot;
        $192dba6b716d8535$var$_wipRoot = null;
        $192dba6b716d8535$var$_commitWork($192dba6b716d8535$var$_firstEffect);
        return;
    }
    while($192dba6b716d8535$var$_nextUnitOfWork && deadline.timeRemaining() > 0)$192dba6b716d8535$var$_nextUnitOfWork = $192dba6b716d8535$var$_performUnitOfWork($192dba6b716d8535$var$_nextUnitOfWork);
    $192dba6b716d8535$var$scheduler($192dba6b716d8535$var$_workLoop);
};
const $192dba6b716d8535$export$60241385465d0a34 = (initialValue)=>{
    $192dba6b716d8535$var$_hookIndex++;
    const fiber = $192dba6b716d8535$var$_nextUnitOfWork;
    if (!fiber) throw new Error("WAT");
    if (!fiber.hooks[$192dba6b716d8535$var$_hookIndex]) fiber.hooks[$192dba6b716d8535$var$_hookIndex] = {
        type: "state",
        pending: [],
        value: initialValue instanceof Function ? initialValue() : initialValue,
        dispatch: (arg)=>{
            hook.pending.push(arg);
            $192dba6b716d8535$var$_wipRoot = $192dba6b716d8535$var$_createFiber({
                ...$192dba6b716d8535$var$_currentRoot,
                tag: "root",
                type: $192dba6b716d8535$var$ROOT,
                visited: false,
                child: null,
                sibling: null,
                alternate: $192dba6b716d8535$var$_currentRoot
            });
            $192dba6b716d8535$var$_nextUnitOfWork = $192dba6b716d8535$var$_wipRoot;
            $192dba6b716d8535$var$_firstEffect = null;
            $192dba6b716d8535$var$_lastEffect = null;
            $192dba6b716d8535$var$scheduler($192dba6b716d8535$var$_workLoop);
        }
    };
    const hook = fiber.hooks[$192dba6b716d8535$var$_hookIndex];
    if (!$192dba6b716d8535$var$_isStateHook(hook)) throw new Error("WAT");
    hook.value = hook.pending.reduce((acc, curr)=>curr instanceof Function ? curr(acc) : curr, hook.value);
    hook.pending = [];
    return [
        hook.value,
        hook.dispatch
    ];
};
const $192dba6b716d8535$export$1538c33de8887b59 = (makeValue, deps)=>{
    $192dba6b716d8535$var$_hookIndex++;
    const fiber = $192dba6b716d8535$var$_nextUnitOfWork;
    if (!fiber) throw new Error("WAT");
    if (!fiber.hooks[$192dba6b716d8535$var$_hookIndex]) fiber.hooks[$192dba6b716d8535$var$_hookIndex] = {
        type: "memo",
        value: makeValue(),
        deps: deps
    };
    const hook = fiber.hooks[$192dba6b716d8535$var$_hookIndex];
    if (!$192dba6b716d8535$var$_isMemoHook(hook)) throw new Error("WAT");
    if (!$192dba6b716d8535$var$_depsEqual(hook.deps, deps)) {
        hook.value = makeValue();
        hook.deps = deps;
    }
    return hook.value;
};
const $192dba6b716d8535$export$35808ee640e87ca7 = (cb, deps)=>$192dba6b716d8535$export$1538c33de8887b59(()=>cb, deps);
const $192dba6b716d8535$export$6d9c69b0de29b591 = (setup, deps)=>{
    $192dba6b716d8535$var$_hookIndex++;
    const fiber = $192dba6b716d8535$var$_nextUnitOfWork;
    if (!fiber) throw new Error("WAT");
    const prevHook = fiber.hooks[$192dba6b716d8535$var$_hookIndex];
    if (!prevHook) {
        fiber.hooks[$192dba6b716d8535$var$_hookIndex] = {
            type: "effect",
            deps: deps,
            depsChanged: true,
            setup: setup
        };
        return;
    }
    const hook = fiber.hooks[$192dba6b716d8535$var$_hookIndex];
    if (!$192dba6b716d8535$var$_isEffectHook(hook)) throw new Error("WAT");
    hook.depsChanged = !deps || !$192dba6b716d8535$var$_depsEqual(hook.deps, deps);
    hook.deps = deps;
    hook.setup = setup;
};
const $192dba6b716d8535$export$b3890eb0ae9dca99 = (el, dom)=>{
    $192dba6b716d8535$var$_wipRoot = $192dba6b716d8535$var$_createFiber({
        key: el.key,
        tag: "root",
        type: $192dba6b716d8535$var$ROOT,
        props: {
            children: [
                el
            ]
        },
        dom: dom,
        alternate: $192dba6b716d8535$var$_currentRoot
    });
    $192dba6b716d8535$var$_nextUnitOfWork = $192dba6b716d8535$var$_wipRoot;
    $192dba6b716d8535$var$scheduler($192dba6b716d8535$var$_workLoop);
};
const $192dba6b716d8535$export$2a1067a5cfac8182 = (dom)=>{
    dom.innerHTML = "";
    $192dba6b716d8535$var$_nextUnitOfWork = null;
    $192dba6b716d8535$var$_currentRoot = null;
    $192dba6b716d8535$var$_wipRoot = null;
    $192dba6b716d8535$var$_firstEffect = null;
    $192dba6b716d8535$var$_lastEffect = null;
    $192dba6b716d8535$var$_hookIndex = -1;
};
const $192dba6b716d8535$export$58d9b47aed469249 = {
    setScheduler: (fn)=>$192dba6b716d8535$var$scheduler = fn
};


const $75f8b2e603f97704$export$c4ddc81c7b2c8d7a = [
    "all",
    "active",
    "completed"
];


const $ae06143e6397cd41$export$7c1393839656cd16 = (candidate)=>(0, $75f8b2e603f97704$export$c4ddc81c7b2c8d7a).includes(candidate);


/* @jsx createElement */ 
const $b0f0fb6be31f4180$export$f420dabf4645c8f7 = ({ onNewTodo: onNewTodo })=>{
    const [text, setText] = (0, $192dba6b716d8535$export$60241385465d0a34)("");
    const handleInput = (0, $192dba6b716d8535$export$35808ee640e87ca7)((e)=>{
        setText(e.target.value);
    }, [
        setText
    ]);
    const handleKeyDown = (0, $192dba6b716d8535$export$35808ee640e87ca7)((e)=>{
        if (e.keyCode !== 13) return;
        onNewTodo(e.target.value);
        setText("");
    }, [
        onNewTodo,
        setText
    ]);
    return /*#__PURE__*/ (0, $192dba6b716d8535$export$c8a8987d4410bf2d)("input", {
        value: text,
        onInput: handleInput,
        onKeyDown: handleKeyDown,
        className: "new-todo",
        placeholder: "What needs to be done?"
    });
};




/* @jsx createElement */ /* @jsxFrag Fragment */ 
const $f025501d073cf39e$export$c25574be91c3ef80 = ({ all: all, onToggle: onToggle })=>{
    const handleToggle = (0, $192dba6b716d8535$export$35808ee640e87ca7)((e)=>{
        onToggle(e.target.checked);
    }, [
        onToggle
    ]);
    return /*#__PURE__*/ (0, $192dba6b716d8535$export$c8a8987d4410bf2d)((0, $192dba6b716d8535$export$ffb0004e005737fa), null, /*#__PURE__*/ (0, $192dba6b716d8535$export$c8a8987d4410bf2d)("input", {
        id: "toggle-all",
        className: "toggle-all",
        type: "checkbox",
        checked: all,
        onChange: handleToggle
    }), /*#__PURE__*/ (0, $192dba6b716d8535$export$c8a8987d4410bf2d)("label", {
        for: "toggle-all"
    }));
};




/* @jsx createElement */ 
/* @jsx createElement */ 
const $4d42329efe8a5c74$export$de515f7f7fedd6e3 = ({ data: data, onToggle: onToggle, onDestroy: onDestroy })=>/*#__PURE__*/ (0, $192dba6b716d8535$export$c8a8987d4410bf2d)("li", {
        className: data.completed ? "completed" : ""
    }, /*#__PURE__*/ (0, $192dba6b716d8535$export$c8a8987d4410bf2d)("div", {
        className: "view"
    }, /*#__PURE__*/ (0, $192dba6b716d8535$export$c8a8987d4410bf2d)("input", {
        className: "toggle",
        type: "checkbox",
        checked: data.completed,
        onChange: ()=>onToggle(data)
    }), /*#__PURE__*/ (0, $192dba6b716d8535$export$c8a8987d4410bf2d)("label", null, data.body), /*#__PURE__*/ (0, $192dba6b716d8535$export$c8a8987d4410bf2d)("button", {
        className: "destroy",
        onClick: ()=>onDestroy(data)
    })));




const $3ab739258547970f$export$1637e515a5a47691 = ({ todos: todos, onToggle: onToggle, onDestroy: onDestroy })=>/*#__PURE__*/ (0, $192dba6b716d8535$export$c8a8987d4410bf2d)("ul", {
        className: "todo-list"
    }, todos.map((todo)=>/*#__PURE__*/ (0, $192dba6b716d8535$export$c8a8987d4410bf2d)((0, $4d42329efe8a5c74$export$de515f7f7fedd6e3), {
            key: todo.id,
            data: todo,
            onToggle: onToggle,
            onDestroy: onDestroy
        })));




/* @jsx createElement */ 

const $bc9a425a59337ea3$export$e93a6fd7db584812 = ({ current: current, onChange: onChange })=>/*#__PURE__*/ (0, $192dba6b716d8535$export$c8a8987d4410bf2d)("ul", {
        className: "filters"
    }, (0, $75f8b2e603f97704$export$c4ddc81c7b2c8d7a).map((v)=>/*#__PURE__*/ (0, $192dba6b716d8535$export$c8a8987d4410bf2d)("li", {
            key: v
        }, /*#__PURE__*/ (0, $192dba6b716d8535$export$c8a8987d4410bf2d)("a", {
            className: v === current ? "selected" : "",
            href: `#${v}`,
            onClick: ()=>onChange(v)
        }, v))));





const $959575b7cfb6d0c5$var$Todos = ()=>{
    const [all, setAll] = (0, $192dba6b716d8535$export$60241385465d0a34)(false);
    const [todos, setTodos] = (0, $192dba6b716d8535$export$60241385465d0a34)([]);
    const [currentView, setCurrentView] = (0, $192dba6b716d8535$export$60241385465d0a34)(()=>{
        const candidate = window.location.hash.slice(1);
        if ((0, $ae06143e6397cd41$export$7c1393839656cd16)(candidate)) return candidate;
        return "all";
    });
    const active = (0, $192dba6b716d8535$export$1538c33de8887b59)(()=>todos.filter(({ completed: completed })=>!completed), [
        todos
    ]);
    const completed = (0, $192dba6b716d8535$export$1538c33de8887b59)(()=>todos.filter(({ completed: completed })=>completed), [
        todos
    ]);
    const visible = (0, $192dba6b716d8535$export$1538c33de8887b59)(()=>{
        switch(currentView){
            case "all":
                return todos;
            case "active":
                return active;
            case "completed":
                return completed;
        }
    }, [
        currentView,
        todos,
        active,
        completed
    ]);
    const handleAdd = (0, $192dba6b716d8535$export$35808ee640e87ca7)((text)=>{
        if (!text.length) return;
        setTodos((prev)=>[
                ...prev,
                {
                    id: crypto.randomUUID(),
                    body: text,
                    completed: false
                }
            ]);
    }, [
        setTodos
    ]);
    const handleToggle = (0, $192dba6b716d8535$export$35808ee640e87ca7)((todo)=>{
        setTodos((prev)=>prev.map((t)=>t.id === todo.id ? {
                    ...t,
                    completed: !t.completed
                } : t));
    }, [
        setTodos
    ]);
    const handleDestroy = (0, $192dba6b716d8535$export$35808ee640e87ca7)((todo)=>{
        setTodos((prev)=>prev.filter(({ id: id })=>id !== todo.id));
    }, [
        setTodos
    ]);
    const handleClearCompleted = (0, $192dba6b716d8535$export$35808ee640e87ca7)(()=>{
        setTodos(active);
    }, [
        setTodos,
        active
    ]);
    const handleToggleAll = (0, $192dba6b716d8535$export$35808ee640e87ca7)((all)=>{
        setTodos((prev)=>prev.map((todo)=>({
                    ...todo,
                    completed: all
                })));
    }, [
        setTodos
    ]);
    (0, $192dba6b716d8535$export$6d9c69b0de29b591)(()=>{
        setAll(!!todos.length && todos.length === completed.length);
    }, [
        todos,
        completed,
        setAll
    ]);
    return /*#__PURE__*/ (0, $192dba6b716d8535$export$c8a8987d4410bf2d)((0, $192dba6b716d8535$export$ffb0004e005737fa), null, /*#__PURE__*/ (0, $192dba6b716d8535$export$c8a8987d4410bf2d)("section", {
        className: "todoapp"
    }, /*#__PURE__*/ (0, $192dba6b716d8535$export$c8a8987d4410bf2d)("div", null, /*#__PURE__*/ (0, $192dba6b716d8535$export$c8a8987d4410bf2d)("header", {
        className: "header"
    }, /*#__PURE__*/ (0, $192dba6b716d8535$export$c8a8987d4410bf2d)("h1", null, "todos"), /*#__PURE__*/ (0, $192dba6b716d8535$export$c8a8987d4410bf2d)((0, $b0f0fb6be31f4180$export$f420dabf4645c8f7), {
        onNewTodo: handleAdd
    })), /*#__PURE__*/ (0, $192dba6b716d8535$export$c8a8987d4410bf2d)("div", {
        className: "main"
    }, /*#__PURE__*/ (0, $192dba6b716d8535$export$c8a8987d4410bf2d)((0, $f025501d073cf39e$export$c25574be91c3ef80), {
        all: all,
        onToggle: handleToggleAll
    }), /*#__PURE__*/ (0, $192dba6b716d8535$export$c8a8987d4410bf2d)((0, $3ab739258547970f$export$1637e515a5a47691), {
        todos: visible,
        onToggle: handleToggle,
        onDestroy: handleDestroy
    })), todos.length > 0 && /*#__PURE__*/ (0, $192dba6b716d8535$export$c8a8987d4410bf2d)("footer", {
        className: "footer"
    }, active.length > 0 && /*#__PURE__*/ (0, $192dba6b716d8535$export$c8a8987d4410bf2d)("span", {
        className: "todo-count"
    }, active.length, " ", `item${active.length > 1 ? "s" : ""}`, " left"), /*#__PURE__*/ (0, $192dba6b716d8535$export$c8a8987d4410bf2d)((0, $bc9a425a59337ea3$export$e93a6fd7db584812), {
        current: currentView,
        onChange: setCurrentView
    }), completed.length > 0 && /*#__PURE__*/ (0, $192dba6b716d8535$export$c8a8987d4410bf2d)("button", {
        className: "clear-completed",
        onClick: handleClearCompleted
    }, "Clear completed")))), /*#__PURE__*/ (0, $192dba6b716d8535$export$c8a8987d4410bf2d)("footer", {
        className: "info"
    }, /*#__PURE__*/ (0, $192dba6b716d8535$export$c8a8987d4410bf2d)("p", null, /*#__PURE__*/ (0, $192dba6b716d8535$export$c8a8987d4410bf2d)("a", {
        href: "https://github.com/rkrupinski/react/tree/master/packages/example"
    }, "View source"))));
};
const $959575b7cfb6d0c5$var$root = document.querySelector("#root");
(0, $192dba6b716d8535$export$b3890eb0ae9dca99)(/*#__PURE__*/ (0, $192dba6b716d8535$export$c8a8987d4410bf2d)($959575b7cfb6d0c5$var$Todos, null), $959575b7cfb6d0c5$var$root);


//# sourceMappingURL=index.22d2a1e1.js.map
